import React from 'react';
import allSessionsDrills from '../data/sessions_drills.js';
import SportGrid from './SportGrid';
import { useSelectedPlayers } from '../contexts/SelectedPlayersContext';

const SkillsSelection = () => {
  // Derive sports from available skill drills instead of general exercises
  const sports = Array.from(
    new Set((allSessionsDrills || []).map((d) => d.sport))
  ).sort();
  const { selectedPlayersData, removePlayer, addPlayer, allPlayersData } =
    useSelectedPlayers();

  const sportData = {
    soccer: {
      name: 'Soccer',
      icon: '⚽',
      color: '#4CAF50',
    },
    basketball: {
      name: 'Basketball',
      icon: '🏀',
      color: '#FF9800',
    },
    swimming: {
      name: 'Swimming',
      icon: '🏊',
      color: '#2196F3',
    },
    tennis: {
      name: 'Tennis',
      icon: '🎾',
      color: '#9C27B0',
    },
    volleyball: {
      name: 'Volleyball',
      icon: '🏐',
      color: '#F44336',
    },
    football: {
      name: 'Football',
      icon: '🏈',
      color: '#795548',
    },
    baseball: {
      name: 'Baseball',
      icon: '⚾',
      color: '#FF5722',
    },
    track: {
      name: 'Track & Field',
      icon: '🏃',
      color: '#607D8B',
    },
    martial_arts: {
      name: 'Martial Arts',
      icon: '🥷',
      color: '#3F51B5',
    },
    dance: {
      name: 'Dance',
      icon: '💃',
      color: '#FF4081',
    },
    lacrosse: {
      name: 'Lacrosse',
      icon: '🥍',
      color: '#8BC34A',
    },
    rugby: {
      name: 'Rugby',
      icon: '🏉',
      color: '#FF9800',
    },
    cricket: {
      name: 'Cricket',
      icon: '🏏',
      color: '#795548',
    },
    golf: {
      name: 'Golf',
      icon: '⛳',
      color: '#4CAF50',
    },
    hockey: {
      name: 'Hockey',
      icon: '🏒',
      color: '#2196F3',
    },
    karate: {
      name: 'Karate',
      icon: '🥋',
      color: '#3F51B5',
    },
    taekwondo: {
      name: 'Taekwondo',
      icon: '☯',
      color: '#3F51B5',
    },
    'martial-arts': {
      name: 'Martial Arts',
      icon: '🥷',
      color: '#3F51B5',
    },
    ballet: {
      name: 'Ballet',
      icon: '🩰',
      color: '#E91E63',
    },
    boxing: {
      name: 'Boxing',
      icon: '🥊',
      color: '#FF5722',
    },
    yoga: {
      name: 'Yoga',
      icon: '🧘🏻‍♀️',
      color: '#4CAF50',
    },
    'movement-coordination': {
      name: 'Gymnastics',
      icon: '🤸',
      color: '#E91E63',
    },
    gymnastics: {
      name: 'Gymnastics',
      icon: '🤸',
      color: '#E91E63',
    },
    'running-technique': {
      name: 'Running Technique',
      icon: '🏃',
      color: '#607D8B',
    },
  };

  const sportItems = sports.map((sport) => {
    const sportInfo = sportData[sport] || {
      name: sport.charAt(0).toUpperCase() + sport.slice(1).replace('_', ' '),
      icon: '🏆',
      color: '#666',
    };

    return {
      icon: sportInfo.icon,
      title: sportInfo.name,
      color: sportInfo.color,
      link: sport,
    };
  });

  return (
    <SportGrid
      title='Skills Training'
      subtitle='Choose a sport to practice specific skills and drills. Build your technique step by step!'
      items={sportItems}
      showBackButton={true}
      backButtonText='← Back to Players'
      backButtonPath='/skills/players'
      itemLinkPrefix='/skills/sports/'
      selectedPlayers={selectedPlayersData}
      onRemovePlayer={removePlayer}
      onAddPlayer={addPlayer}
      allPlayers={allPlayersData}
    />
  );
};

export default SkillsSelection;
